import global from './global';

export default {
  namespaced: true,
  modules: {
    global,
  }
};
